import { Table } from "../../../features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import {
  type C3Portfolio,
  porfolios_columns,
  columnVisibilityInit,
} from "./columns";
import { type FilterC3PortfoliosSchema, FilterC3Portfolios } from "./filter";

const client = Clients.C3;
const table_name = Tables.C3_PORTFOLIOS;

export const C3PortfoliosTable = () => {
  return (
    <Table<C3Portfolio, FilterC3PortfoliosSchema>
      label="Portfolios"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      columnVisibilityInit={columnVisibilityInit}
      filter={<FilterC3Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
